<section class="row">
  <div class="col-12" style="padding-right: 0px; padding-left: 0px">
    <div class="card card-form">
      <ng-container *ngIf="ehColaborador; else ehBeneficiario">
        <!-- Área do Colaborador -->
        <app-proposta-beneficiario-colaborador
          [listaEnumTipoProposta]="listaEnumTipoProposta"
          [listaEstatusCivil]="listaEstatusCivil"
          [_listaGeneros]="_listaGeneros"
          [listaProfissao]="listaProfissao"
          [ehColaborador]="ehColaborador"
          [entidadeId]="entidadeId"></app-proposta-beneficiario-colaborador>
      </ng-container>
      <ng-template #ehBeneficiario>
        <block-ui [template]="blockTemplate">
          <div class="latest-blog-loop bg-white">
            <ng-container>
              <mat-horizontal-stepper [selectedIndex]="stepAtual" [linear]="isLinear" #stepper>
                <!-- passo 1 - Manual de Orientação -->
                <mat-step label="CONCORDO {{ stepper.selectedIndex }}">
                  <!-- Modal do Manual -->
                  <ng-template #modalManual let-modal>
                    <div class="modal-header">
                      <h4 class="modal-title">Manual de Orientação do Beneficiário</h4>
                    </div>
                    <div class="modal-content">
                      <div class="modal-body">
                        <app-manual-orientacao-proposta
                          [dadosOperadoraDM]="dadosOperadoraDM"></app-manual-orientacao-proposta>
                      </div>
                      <div class="row">
                        <div class="mb-1 mt-2 ml-3">
                          <input type="checkbox" [(ngModel)]="checkboxManualBeneficiario" id="checkboxManual" />
                          <label class="termo-aceite bold alinhamento-texto-check-box" for="checkboxManual">
                            Li o Manual de Orientação do Beneficiário
                            <a class="ml-1"></a>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        [disabled]="!checkboxManualBeneficiario"
                        (click)="concordarManual()"
                        class="btn btn-success round">
                        <i class="fa fa-check"></i>
                        Concordo
                      </button>
                    </div>
                  </ng-template>
                </mat-step>
                <!-- passo 2 - Entidade Associada -->
                <mat-step label="ASSOCIADO {{ stepper.selectedIndex }}">
                  <div class="card-header card-form-header mt-1">
                    <div class="form-section">
                      <div class="d-flex mt-1" style="justify-content: center">
                        <p class="d-flex align-items-center">
                          É associado a {{ nomeEntidade }} - {{ razaoSocialEntidade }}?
                        </p>
                      </div>
                      <div
                        class="d-flex align-items-center mt-3 sou-associado-mobile"
                        style="justify-content: space-evenly">
                        <button
                          data-dismiss="modal"
                          type="button"
                          style="
                            min-width: 220px !important;
                            box-shadow:
                              rgba(0, 0, 0, 0.19) 0px 10px 20px,
                              rgba(0, 0, 0, 0.23) 0px 6px 6px;
                          "
                          class="btn btn-round btn-geia-info btn-outline-info btn-min-width box-shadow-4 mr-1 mb-1"
                          [ngClass]="{
                            'btn-pressionado': propostaAssossiada === true
                          }"
                          (click)="heAssociado(stepper, true)">
                          SOU ASSOCIADO
                        </button>

                        <button
                          data-dismiss="modal"
                          type="button"
                          style="
                            min-width: 220px !important;
                            box-shadow:
                              rgba(0, 0, 0, 0.19) 0px 10px 20px,
                              rgba(0, 0, 0, 0.23) 0px 6px 6px;
                          "
                          class="btn btn-round btn-geia-info btn-outline-info btn-min-width box-shadow-4 mr-1 mb-1"
                          [ngClass]="{
                            'btn-pressionado': propostaAssossiada === false
                          }"
                          (click)="heAssociado(stepper, false)">
                          DESEJO ME CADASTRAR
                        </button>
                      </div>
                    </div>
                  </div>
                </mat-step>
                <!-- passo 3 - Formulário Titular/Dependente -->
                <mat-step label="TITULAR {{ stepper.selectedIndex }}">
                  <!-- Botão para abrir o modal documento final -->
                  <div class="card-header card-form-header mt-1 espacamento-form-mobile" style="padding: 0% !important">
                    <!-- Fomulário do Titular -->
                    <div class="card collapse-icon accordion-icon-rotate" style="margin-bottom: 1rem">
                      <!-- Dados Cadastrais -->
                      <div
                        id="headingCollapse51"
                        class="card-header collapse-format"
                        [ngClass]="errorMessage == false ? 'border-info' : 'border-danger'">
                        <a
                          data-toggle="collapse"
                          href="#collapseLeads"
                          aria-expanded="false"
                          aria-controls="collapseLeads"
                          class="card-title lead info"
                          [ngClass]="errorMessage == false ? 'info' : 'danger'">
                          <i class="fa fa-user" aria-hidden="true"></i>
                          Dados do Titular
                          <i
                            style="color: red"
                            *ngIf="errorMessage"
                            placement="top"
                            ngbTooltip="Verifique os campos obrigatórios."
                            class="cursor-pointer fa fa-exclamation-triangle"
                            aria-hidden="true"></i>
                        </a>
                      </div>
                      <div
                        id="collapseLeads"
                        role="tabpanel"
                        aria-labelledby="headingCollapseLeads"
                        class="card-collapse collapse"
                        aria-expanded="false">
                        <div class="card-content">
                          <div class="card-body espacamento-form-mobile">
                            <form [formGroup]="formBeneficiario">
                              <div class="col-12">
                                <div class="form-group row">
                                  <!-- Nome -->
                                  <div
                                    [ngClass]="dependentInclusion ? ' col-md-5' : ' col-md-8'"
                                    class="form-group mb-1 col-sm-12">
                                    <label for="name">Nome Completo</label>
                                    <input
                                      (ngModelChange)="onFieldChange()"
                                      type="text"
                                      class="form-control round"
                                      id="name"
                                      maxlength="250"
                                      formControlName="name"
                                      [ngClass]="{
                                        'is-invalid': formBeneficiario.controls['name'].errors && isFormSubmited
                                      }" />
                                    <app-validacao-form-input
                                      [nomeFormulario]="formBeneficiario"
                                      nomeCampo="name"
                                      [maxLength]="250"
                                      [minLength]="10"
                                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                                  </div>
                                  <!-- Tipo de Proposta -->

                                  <div *ngIf="!dependentInclusion" class="form-group col-sm-12 col-md-4">
                                    <label for="proposalType">Tipo de Proposta</label>
                                    <ng-select
                                      id="proposalType"
                                      class="round shadow somente-leitura"
                                      [multiple]="false"
                                      [loading]="false"
                                      [closeOnSelect]="true"
                                      [searchable]="true"
                                      [readonly]="true"
                                      formControlName="proposalType"
                                      notFoundText="Nenhum registro localizado">
                                      <ng-option *ngFor="let option of listaEnumTipoProposta" [value]="option.value">
                                        {{ option.description }}
                                      </ng-option>
                                    </ng-select>
                                  </div>
                                  <!-- CPF -->
                                  <div
                                    [ngClass]="dependentInclusion ? ' col-md-2' : ' col-md-4'"
                                    class="form-group mb-1 col-sm-12">
                                    <label for="cpf">CPF</label>
                                    <input
                                      name="cpf"
                                      (ngModelChange)="onFieldChange()"
                                      [showMaskTyped]="true"
                                      mask="000.000.000-00"
                                      formControlName="cpf"
                                      class="form-control border-radius"
                                      [ngClass]="{
                                        'is-invalid':
                                          formBeneficiario.controls['cpf'].invalid &&
                                          formBeneficiario.controls['cpf'].errors &&
                                          isFormSubmited
                                      }"
                                      id="cpf" />
                                    <app-validacao-form-input
                                      [nomeFormulario]="formBeneficiario"
                                      nomeCampo="cpf"
                                      [maxLength]="250"
                                      [minLength]="10"
                                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                                  </div>
                                  <!-- Data de Nascimento -->
                                  <div
                                    class="col-12 col-sm-12 mb-2"
                                    [ngClass]="dependentInclusion ? ' col-md-3' : ' col-md-4'">
                                    <label for="birthDate">Data de Nascimento</label>
                                    <div class="input-group">
                                      <input
                                        #datepicker="bsDatepicker"
                                        bsDatepicker
                                        name="birthDate"
                                        maxlength="10"
                                        type="text"
                                        class="form-control round bg-white"
                                        id="birthDate"
                                        [minDate]="minDate"
                                        [maxDate]="maxDate"
                                        [bsConfig]="bsConfig"
                                        formControlName="birthDate"
                                        [ngClass]="{
                                          'is-invalid': formBeneficiario.controls['birthDate'].errors && isFormSubmited
                                        }"
                                        (focus)="campoDataSelecionado($event)"
                                        (ngModelChange)="formatarCampoData($event, 'birthDate')"
                                        (onShown)="esconderCalendario()" />

                                      <div class="input-group-append">
                                        <button
                                          class="btn btn-secondary round botao-calendario"
                                          type="button"
                                          (click)="mostrarCalendario()">
                                          <i class="fa fa-calendar"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- Estado Civil -->
                                  <div
                                    class="form-group col-sm-12"
                                    [ngClass]="dependentInclusion ? ' col-md-2' : ' col-md-4'">
                                    <label for="civilStatusId">Estado Civil</label>
                                    <ng-select
                                      (ngModelChange)="onFieldChange()"
                                      [multiple]="false"
                                      [loading]="false"
                                      [closeOnSelect]="true"
                                      [searchable]="true"
                                      class="round shadow"
                                      formControlName="civilStatusId"
                                      [ngClass]="{
                                        'is-invalid':
                                          formBeneficiario.controls['civilStatusId'].errors && isFormSubmited
                                      }"
                                      notFoundText="Nenhum registro localizado">
                                      <ng-option *ngFor="let estadoCivil of listaEstatusCivil" [value]="estadoCivil.id">
                                        {{ estadoCivil.name }}
                                      </ng-option>
                                    </ng-select>
                                    <app-validacao-form-input
                                      [nomeFormulario]="formBeneficiario"
                                      nomeCampo="civilStatusId"
                                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                                  </div>
                                  <!-- Sexo -->
                                  <div class="form-group mb-1 col-sm-12 col-md-4">
                                    <label for="sex">Sexo</label>
                                    <br />
                                    <label style="margin-right: 50px">
                                      <input
                                        [ngClass]="{
                                          'is-invalid': formBeneficiario.controls['sex'].errors && isFormSubmited
                                        }"
                                        (ngModelChange)="onFieldChange()"
                                        formControlName="sex"
                                        [value]="1"
                                        id="active"
                                        type="radio"
                                        class="input-radio off"
                                        name="sex"
                                        checked />
                                      Masculino
                                    </label>
                                    <label>
                                      <input
                                        [ngClass]="{
                                          'is-invalid': formBeneficiario.controls['sex'].errors && isFormSubmited
                                        }"
                                        (ngModelChange)="onFieldChange()"
                                        formControlName="sex"
                                        [value]="2"
                                        id="Inactive"
                                        type="radio"
                                        class="input-radio on"
                                        name="sex" />
                                      Feminino
                                    </label>
                                    <app-validacao-form-input
                                      [nomeFormulario]="formBeneficiario"
                                      nomeCampo="sex"
                                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                                  </div>
                                  <!-- Gênero -->
                                  <div class="form-group mb-1 col-sm-12 col-md-4">
                                    <label for="gender">Gênero</label>
                                    <ng-select
                                      (change)="onChangeGender($event)"
                                      [multiple]="false"
                                      [loading]="false"
                                      [closeOnSelect]="true"
                                      [searchable]="true"
                                      notFoundText="Nenhum registro localizado"
                                      class="round shadow"
                                      formControlName="gender">
                                      <ng-option *ngFor="let genero of _listaGeneros" [value]="genero.value">
                                        {{ genero.description }}
                                      </ng-option>
                                    </ng-select>
                                  </div>
                                  <!-- Outro Gênero  -->
                                  <div *ngIf="isOtherGender" class="form-group col-sm-12 col-md-4">
                                    <label for="otherGender">Outro Gênero</label>
                                    <input
                                      [ngClass]="{
                                        'is-invalid': formBeneficiario.controls['otherGender'].errors && isFormSubmited
                                      }"
                                      (change)="onChangeGender($event)"
                                      class="round form-control"
                                      id="otherGender"
                                      formControlName="otherGender" />
                                    <app-validacao-form-input
                                      [nomeFormulario]="formBeneficiario"
                                      nomeCampo="otherGender"
                                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                                  </div>
                                  <!-- CNS -->
                                  <div class="form-group mb-1 col-sm-12 col-md-4">
                                    <ng-template #faqTemplateCNS>
                                      <app-faqs [fieldName]="'CNS'"></app-faqs>
                                    </ng-template>
                                    <label for="cns">
                                      CNS
                                      <a
                                        href="https://cnesadm.datasus.gov.br/cnesadm/publico/usuarios/cadastro"
                                        target="_blank"
                                        class="input-icon">
                                        <i
                                          placement="top"
                                          aria-hidden="true"
                                          class="fa fa fa-exclamation-circle"
                                          tooltipClass="tooltip"></i>
                                      </a>
                                    </label>
                                    <input
                                      [ngClass]="{
                                        'is-invalid': formBeneficiario.controls['cns'].errors && isFormSubmited
                                      }"
                                      mask="000 0000 0000 0000"
                                      (ngModelChange)="onFieldChange()"
                                      [showMaskTyped]="true"
                                      type="text"
                                      class="form-control round"
                                      id="cns"
                                      formControlName="cns" />
                                    <app-validacao-form-input
                                      [nomeFormulario]="formBeneficiario"
                                      nomeCampo="cns"
                                      [maxLength]="250"
                                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                                  </div>
                                  <!-- Nome da Mãe -->
                                  <div
                                    class="form-group mb-1 col-sm-12 col-md-6"
                                    [ngClass]="isOtherGender ? 'col-md-8' : 'col-md-6'">
                                    <label for="mothersName">Nome da Mãe</label>
                                    <input
                                      (ngModelChange)="onFieldChange()"
                                      type="text"
                                      class="form-control round"
                                      id="mothersName"
                                      maxlength="250"
                                      [ngClass]="{
                                        'is-invalid': formBeneficiario.controls['mothersName'].errors && isFormSubmited
                                      }"
                                      formControlName="mothersName" />
                                    <app-validacao-form-input
                                      [nomeFormulario]="formBeneficiario"
                                      nomeCampo="mothersName"
                                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                                    <div
                                      class="errorsName"
                                      *ngIf="
                                        formBeneficiario.get('mothersName')?.invalid &&
                                        (formBeneficiario.get('mothersName')?.touched ||
                                          formBeneficiario.get('mothersName')?.dirty)
                                      ">
                                      <div
                                        class="errorsName"
                                        *ngIf="formBeneficiario.get('mothersName')?.hasError('checkName')">
                                        {{ formBeneficiario.get('mothersName')?.errors?.['checkName'] }}
                                      </div>
                                    </div>
                                  </div>
                                  <!-- Profissão -->
                                  <div class="form-group mb-1 col-sm-12 col-md-6">
                                    <label for="professionId">Profissão</label>
                                    <ng-select
                                      (change)="onChangeProfession($event)"
                                      (ngModelChange)="onFieldChange()"
                                      [multiple]="false"
                                      [loading]="false"
                                      [closeOnSelect]="true"
                                      [searchable]="true"
                                      notFoundText="Nenhum registro localizado"
                                      class="round shadow"
                                      [ngClass]="{
                                        'campo-obrigatorio':
                                          formBeneficiario.controls['professionId'].errors && isFormSubmited
                                      }"
                                      formControlName="professionId">
                                      <ng-option *ngFor="let profisao of listaProfissao" [value]="profisao.id">
                                        {{ profisao.name }}
                                      </ng-option>
                                    </ng-select>
                                    <app-validacao-form-input
                                      [nomeFormulario]="formBeneficiario"
                                      nomeCampo="professionId"
                                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                                  </div>
                                  <!-- Outras Profissões  -->
                                  <div *ngIf="isOtherProfession" class="form-group col-sm-12 col-md-6">
                                    <label for="otherProfession">Outra Profissão</label>
                                    <input
                                      [ngClass]="{
                                        'is-invalid':
                                          formBeneficiario.controls['otherProfession'].errors && isFormSubmited
                                      }"
                                      (change)="onChangeProfession($event)"
                                      class="round form-control"
                                      id="otherProfession"
                                      formControlName="otherProfession" />
                                    <app-validacao-form-input
                                      [nomeFormulario]="formBeneficiario"
                                      nomeCampo="otherProfession"
                                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                                  </div>
                                  <!-- Informações de Contato -->
                                  <h4 class="form-section col-sm-12 col-md-12 mt-2">
                                    <i class="fa fa-address-book"></i>
                                    Informações de Contato
                                  </h4>
                                  <!-- Email -->
                                  <div class="form-group mb-1 col-sm-12 col-md-8">
                                    <label for="email">E-mail</label>
                                    <input
                                      type="text"
                                      class="form-control round"
                                      id="email"
                                      formControlName="email"
                                      (ngModelChange)="onFieldChange()"
                                      [required]="condionalDeObrigatoriedadeContatos()"
                                      [maxlength]="249"
                                      [ngClass]="{
                                        'is-invalid': formBeneficiario.controls['email'].errors && isFormSubmited
                                      }" />
                                    <app-validacao-form-input
                                      [nomeFormulario]="formBeneficiario"
                                      nomeCampo="email"
                                      [maxLength]="250"
                                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                                    <div
                                      class="errors"
                                      *ngIf="
                                        formBeneficiario.get('email')?.invalid &&
                                        (formBeneficiario.get('email')?.touched || formBeneficiario.get('email')?.dirty)
                                      ">
                                      <div class="errors" *ngIf="formBeneficiario.get('email')?.hasError('checkEmail')">
                                        {{ formBeneficiario.get('email')?.errors?.['checkEmail'] }}
                                      </div>
                                    </div>
                                  </div>
                                  <!-- Telefone Comercial-->
                                  <div class="form-group col-md-4 col-sm-12">
                                    <label for="businessPhone">Telefone Comercial</label>
                                    <input
                                      mask="(00) 0000-0000"
                                      [showMaskTyped]="true"
                                      class="round form-control"
                                      formControlName="businessPhone"
                                      (ngModelChange)="onFieldChange()"
                                      [required]="condionalDeObrigatoriedadeContatos()"
                                      [ngClass]="{
                                        'is-invalid':
                                          formBeneficiario.controls['businessPhone'].errors && isFormSubmited
                                      }"
                                      type="text" />
                                    <app-validacao-form-input
                                      [nomeFormulario]="formBeneficiario"
                                      nomeCampo="businessPhone"
                                      [maxLength]="14"
                                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                                  </div>
                                  <!-- Telefone Residencial-->
                                  <div class="form-group col-md-4 col-sm-12">
                                    <label for="homePhone">Telefone Residencial</label>
                                    <input
                                      mask="(00) 0000-0000"
                                      [showMaskTyped]="true"
                                      class="round form-control"
                                      formControlName="homePhone"
                                      (ngModelChange)="onFieldChange()"
                                      [required]="condionalDeObrigatoriedadeContatos()"
                                      [ngClass]="{
                                        'is-invalid': formBeneficiario.controls['homePhone'].errors && isFormSubmited
                                      }"
                                      type="text" />
                                    <app-validacao-form-input
                                      [nomeFormulario]="formBeneficiario"
                                      nomeCampo="homePhone"
                                      [maxLength]="250"
                                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                                  </div>
                                  <!-- Celular -->
                                  <div class="form-group col-md-4 col-sm-12 mb-2">
                                    <label for="mobilePhone">Celular</label>
                                    <input
                                      mask="(00) 00000-0000"
                                      [showMaskTyped]="true"
                                      class="round box-shadow-4 form-control"
                                      formControlName="mobilePhone"
                                      type="text"
                                      (ngModelChange)="onFieldChange()"
                                      [required]="condionalDeObrigatoriedadeContatos()"
                                      [ngClass]="{
                                        'is-invalid': formBeneficiario.controls['mobilePhone'].errors && isFormSubmited
                                      }" />
                                    <app-validacao-form-input
                                      [nomeFormulario]="formBeneficiario"
                                      nomeCampo="mobilePhone"
                                      [maxLength]="250"
                                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                                  </div>
                                  <ng-container *ngIf="!heOdonto && !dependentInclusion">
                                    <!-- Dados da Operadora e Atendimento - Titular -->
                                    <h4 class="form-section col-sm-12 col-md-12 mt-2">
                                      <i class="fa fa-address-book"></i>
                                      Dados da Operadora e Atendimento - Titular
                                    </h4>
                                    <!-- *ngIf="analiseOperadoraAnterior"Formulário de Análise da Operadora Anterior -->
                                    <!-- Operadora Anterior -->
                                    <div
                                      class="form-group mb-1 col-sm-12 col-md-8 tamanho-campo-grande-formulario-tablet">
                                      <label for="PreviousOperator">Operadora Anterior</label>
                                      <input
                                        maxlength="250"
                                        [ngClass]="{
                                          'is-invalid':
                                            formBeneficiario.controls['previousOperator'].errors && isFormSubmited
                                        }"
                                        (ngModelChange)="onFieldChange()"
                                        type="text"
                                        class="form-control round"
                                        id="previousOperator"
                                        [required]="condicionalDeObrigatoriedadeOperadoraAnterior()"
                                        formControlName="previousOperator" />
                                      <app-validacao-form-input
                                        [nomeFormulario]="formBeneficiario"
                                        nomeCampo="previousOperator"
                                        [maxLength]="250"
                                        [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                                    </div>
                                    <!-- Tempo de Permanência -->
                                    <div
                                      class="form-group mb-1 col-sm-12 col-md-4 tamanho-campo-medio-formulario-tablet">
                                      <label for="dwellTime">Tempo de Permanência</label>
                                      <input
                                        (ngModelChange)="onFieldChange()"
                                        type="number"
                                        class="form-control round"
                                        id="dwellTime"
                                        formControlName="dwellTime"
                                        [ngClass]="{
                                          'is-invalid': formBeneficiario.controls['dwellTime'].errors && isFormSubmited
                                        }"
                                        [required]="condicionalDeObrigatoriedadeOperadoraAnterior()"
                                        min="0"
                                        oninput="
                                          this.value = Math.min(parseInt(this.value))
                                            .toString()
                                            .replace(/[^0-9]/g, '')
                                        " />
                                      <app-validacao-form-input
                                        [nomeFormulario]="formBeneficiario"
                                        nomeCampo="dwellTime"
                                        [maxLength]="250"
                                        [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                                    </div>
                                    <!-- Estado -->
                                    <div class="form-group col-sm-12 col-md-4 tamanho-campo-medio-formulario-tablet">
                                      <label for="stateId">Estado</label>
                                      <ng-select
                                        [multiple]="false"
                                        [loading]="false"
                                        [closeOnSelect]="true"
                                        [searchable]="true"
                                        notFoundText="Nenhum registro localizado"
                                        [ngClass]="{
                                          'campo-obrigatorio':
                                            formBeneficiario.controls['stateId'].errors && isFormSubmited
                                        }"
                                        (change)="onChangeState($event)"
                                        [required]="condicionalDeObrigatoriedadeOperadoraAnterior()"
                                        class="round shadow"
                                        formControlName="stateId">
                                        <ng-option *ngFor="let estado of listaEstados" [value]="estado.id">
                                          {{ estado.name }}
                                        </ng-option>
                                      </ng-select>
                                      <app-validacao-form-input
                                        [nomeFormulario]="formBeneficiario"
                                        nomeCampo="stateId"
                                        [maxLength]="250"
                                        [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                                    </div>
                                    <!-- Cidade -->
                                    <div class="form-group col-sm-12 col-md-4 tamanho-campo-medio-formulario-tablet">
                                      <label for="cityId ">Cidade</label>
                                      <ng-select
                                        [multiple]="false"
                                        [loading]="false"
                                        [closeOnSelect]="true"
                                        [searchable]="true"
                                        notFoundText="Nenhum registro localizado"
                                        [ngClass]="{
                                          'campo-obrigatorio':
                                            formBeneficiario.controls['cityId'].errors && isFormSubmited
                                        }"
                                        class="round shadow"
                                        [required]="condicionalDeObrigatoriedadeOperadoraAnterior()"
                                        formControlName="cityId">
                                        <ng-option *ngFor="let cidade of listaCidades" [value]="cidade.id">
                                          {{ cidade.name }}
                                        </ng-option>
                                      </ng-select>
                                      <app-validacao-form-input
                                        [nomeFormulario]="formBeneficiario"
                                        nomeCampo="cityId"
                                        [maxLength]="250"
                                        [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                                    </div>
                                    <!-- Documentos Redução de Carências -->
                                    <!-- <ng-container *ngIf="analiseOperadoraAnterior">
                                      <div class="input-group mb-1 col-sm-12 col-md-6">
                                        <label for="cat">Carta de Tempo de Permanência</label>
                                        <br />
                                         <div
                                          class="input-group mb-2"
                                          *ngIf="
                                            !temDocumentoCTPExistente() ||
                                            mostrarInputUploadCTP ||
                                            novoArquivoCTPSelecionado
                                          "
                                          class="input-group">
                                          <input
                                            placeholder="Selecione um arquivo para upload"
                                            type="file"
                                            class="form-control round"
                                            id="fileCTP"
                                            accept=".pdf,.jpg,.jpeg,.png"
                                            (change)="onFileCTPSelected($event)" />
                                          <div *ngIf="mostrarInputUploadCTP" class="input-group-append">
                                            <button
                                              type="button"
                                              class="btn btn-inputs btn-secondary round"
                                              (click)="cancelarUploadCTP()">
                                              <i class="fa fa-times"></i>
                                              Cancelar
                                            </button>
                                          </div>
                                        </div>
                                         <div
                                          *ngIf="temDocumentoCTPExistente() && !novoArquivoCTPSelecionado"
                                          class="input-group mt-1">
                                          <input
                                            type="text"
                                            class="form-control round"
                                            [value]="getNomeArquivoCTP()"
                                            readonly
                                            placeholder="Arquivo atual" />
                                          <div class="input-group-append mb-1">
                                            <button
                                              style="max-height: 40px"
                                              type="button"
                                              class="btn btn-success btn-inputs"
                                              (click)="baixarDocumentoCTP()">
                                              <i class="fa fa-download"></i>
                                              Baixar
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="input-group mb-1 col-sm-12 col-md-6">
                                        <label for="carta2">Documento de Adimplância do Plano de Origem</label>
                                        <br />
                                         <div
                                          *ngIf="
                                            !temDocumentoDAPOExistente() ||
                                            mostrarInputUploadDAPO ||
                                            novoArquivoDAPOSelecionado
                                          "
                                          class="input-group">
                                          <input
                                            placeholder="Selecione um arquivo para upload"
                                            type="file"
                                            class="form-control round"
                                            id="fileDAPO"
                                            accept=".pdf,.jpg,.jpeg,.png"
                                            (change)="onFileDAPOSelected($event)" />
                                          <div *ngIf="mostrarInputUploadDAPO" class="input-group-append">
                                            <button
                                              type="button"
                                              class="btn btn-secondary btn-inputs round"
                                              (click)="cancelarUploadDAPO()">
                                              <i class="fa fa-times"></i>
                                              Cancelar
                                            </button>
                                          </div>
                                        </div>


                                        <div
                                          *ngIf="temDocumentoDAPOExistente() && !novoArquivoDAPOSelecionado"
                                          class="input-group mt-1">
                                          <input
                                            type="text"
                                            class="form-control round mb-1"
                                            [value]="getNomeArquivoDAPO()"
                                            readonly
                                            placeholder="Arquivo atual" />
                                          <div class="input-group-append mb-1">
                                            <button
                                              style="max-height: 40px"
                                              type="button"
                                              class="btn btn-success btn-inputs"
                                              (click)="baixarDocumentoDAPO()">
                                              <i class="fa fa-download"></i>
                                              Baixar
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </ng-container> -->
                                    <!-- Condição de Análise da Operadora Anterior -->
                                    <div class="form-group mb-1 mt-2 col-sm-12 col-md-12">
                                      <label
                                        [style.cursor]="
                                          radioButtonReducaoCarenciaSomenteLeitura() ? 'not-allowed' : 'pointer'
                                        "
                                        [style.opacity]="radioButtonReducaoCarenciaSomenteLeitura() ? '0.6' : '1'"
                                        (click)="
                                          radioButtonReducaoCarenciaSomenteLeitura() ? $event.preventDefault() : null
                                        ">
                                        <input
                                          (change)="inserirValidadoresAntigaOperadora(true)"
                                          (ngModelChange)="onFieldChange()"
                                          formControlName="analysisPeriodReductionCheck"
                                          [value]="true"
                                          id="active"
                                          type="radio"
                                          class="input-radio on"
                                          name="analysisPeriodReductionCheck"
                                          [attr.disabled]="
                                            radioButtonReducaoCarenciaSomenteLeitura() ? 'disabled' : null
                                          " />

                                        &nbsp;&nbsp; Desejo submeter-me a Análise Técnica de Redução de Carências e
                                        declaro ter conhecimento de que a análise atenderá a critérios técnicos internos
                                        da administradora, que tem a faculdade de conceder ou não a redução de
                                        carências. (Neste caso, deverá ser preenchido o formulário posterior).
                                      </label>
                                      <label>
                                        <input
                                          checked
                                          (change)="inserirValidadoresAntigaOperadora(false)"
                                          (ngModelChange)="onFieldChange()"
                                          formControlName="analysisPeriodReductionCheck"
                                          [value]="false"
                                          id="Inactive"
                                          type="radio"
                                          class="input-radio off"
                                          name="analysisPeriodReductionCheck" />
                                        &nbsp;&nbsp; Dispenso a Análise Técnica de Redução de Carências e declaro estar
                                        ciente de que ao aderir ao plano de saúde, as coberturas contratuais estarão
                                        condicionadas ao cumprimento dos períodos de carência informados no Quadro 1
                                        acima.
                                      </label>
                                      <app-validacao-form-input
                                        [nomeFormulario]="formBeneficiario"
                                        nomeCampo="analysisPeriodReductionCheck"
                                        [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                                    </div>
                                  </ng-container>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Formulário do Dependente -->
                    <app-proposta-entidade-dependente
                      [somenteLeitura]="ehColaborador"
                      [heOdonto]="heOdonto"
                      [entidadeId]="entidadeId"></app-proposta-entidade-dependente>
                    <!-- Botões -->
                    <div class="button-mobile d-flex justify-content-between w-100 mt-3">
                      <button
                        matStepperPrevious
                        class="btn-simule btn btn-outline-secondary btn-min-width"
                        *ngIf="!this.dependentInclusion; else ehDependenteInclusao">
                        <i class="fa fa-arrow-left"></i>
                        Voltar
                      </button>
                      <ng-template #ehDependenteInclusao>
                        <span></span>
                      </ng-template>
                      <!-- AVANCA TITULAR-->
                      <button
                        (click)="abrirModalConfirmacaoDadosBeneficiario(stepper)"
                        [disabled]="formBeneficiario.invalid || formBeneficiario.errors"
                        [ngbTooltip]="
                          formBeneficiario.invalid ? 'Preencha todos os campos do formulário para prosseguir' : null
                        "
                        class="btn-simule btn btn-outline-secondary btn-min-width">
                        Avançar
                        <i class="fa fa-arrow-right"></i>
                      </button>
                    </div>
                  </div>
                </mat-step>
                <!-- passo 4 -  Dados de Endereço-->
                <mat-step label="ENDERECO {{ stepper.selectedIndex }}">
                  <app-endereco
                    [estaAberto]="true"
                    [mostrarTipoEndereco]="true"
                    [ocultarBtnAcao]="true"
                    [ocultarTabela]="true"></app-endereco>
                  <!-- Botões avanca Endereco -->
                  <div class="button-mobile d-flex justify-content-between w-100 mt-3">
                    <button
                      matStepperPrevious
                      class="btn-simule btn btn-outline-secondary btn-min-whidth"
                      (click)="reatualizarDadosFormulario()">
                      <i class="fa fa-arrow-left"></i>
                      Voltar
                    </button>
                    <!-- -->
                    <button
                      (click)="validarCampos(stepper)"
                      class="btn-simule btn btn-outline-secondary btn-min-whidth">
                      Avançar
                      <i class="fa fa-arrow-right"></i>
                    </button>
                  </div>
                </mat-step>
                <!-- passo 5 - Dados Bancários-->
                <mat-step *ngIf="!dependentInclusion" label="BANCO  {{ stepper.selectedIndex }}">
                  <div class="card collapse-icon accordion-icon-rotate mt-2">
                    <div
                      id="colapseBancohead"
                      class="card-header collapse-format"
                      [ngClass]="mostrarMensagemErroBanco == false ? 'border-info' : 'border-danger'">
                      <a
                        data-toggle="collapse"
                        href="#bancoRef"
                        aria-expanded="true"
                        aria-controls="bancoRef"
                        class="card-title lead info"
                        [ngClass]="mostrarMensagemErroBanco == false ? 'info' : 'danger'">
                        <i class="fa fa-university"></i>
                        Dados Bancários
                        <i
                          style="color: red"
                          *ngIf="mostrarMensagemErroBanco"
                          placement="top"
                          ngbTooltip="Verifique os campos obrigatórios."
                          class="cursor-pointer fa fa-exclamation-triangle"
                          aria-hidden="true"></i>
                      </a>
                    </div>
                    <div
                      id="bancoRef"
                      role="tabpanel"
                      aria-labelledby="colapseBancohead"
                      class="card-collapse collapse show"
                      aria-expanded="true">
                      <h3 class="text-center form-section mt-3">
                        <b>Autorização de Débito em Conta Corrente</b>
                      </h3>
                      <div class="card-content">
                        <div class="card-body espacamento-form-mobile">
                          <!-- Formulário -->
                          <form class="form row" [formGroup]="formGrupDadosBancarios">
                            <!-- Banco *ngIf="bancoConveniado" -->
                            <div
                              class="form-group mb-1 col-sm-12"
                              [ngClass]="bancoConveniado ? 'col-md-12' : 'col-md-6'">
                              <label for="bankId">Banco</label>
                              <ng-select
                                (change)="changeOutroBanco($event, template)"
                                id="bankId"
                                (ngModelChange)="onFieldChange()"
                                class="round shadow"
                                [multiple]="false"
                                [loading]="false"
                                [closeOnSelect]="true"
                                [searchable]="true"
                                formControlName="bankId"
                                required
                                [bindValue]="'id'"
                                notFoundText="Nenhum registro localizado"
                                [ngClass]="{
                                  'campo-obrigatorio':
                                    formGrupDadosBancarios.controls['bankId'].errors && isFormSubmited
                                }">
                                <ng-option *ngFor="let option of listaDeBancosConveniados" [value]="option">
                                  {{ option.name }}
                                </ng-option>
                              </ng-select>
                              <app-validacao-form-input
                                [nomeFormulario]="formGrupDadosBancarios"
                                nomeCampo="bankId"
                                [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                            </div>
                            <!-- *ngIf="!bancoConveniado"k -->
                            <div
                              *ngIf="!bancoConveniado"
                              class="form-group mb-1 col-sm-12 col-md-6"
                              style="margin-bottom: 40px !important">
                              <label for="baotherBankIdnkId">Outros Bancos</label>
                              <ng-select
                                id="otherBankId"
                                (ngModelChange)="onFieldChange()"
                                class="round shadow"
                                [multiple]="false"
                                [loading]="false"
                                [closeOnSelect]="true"
                                [searchable]="true"
                                formControlName="otherBankId"
                                required
                                notFoundText="Nenhum registro localizado"
                                [ngClass]="{
                                  'campo-obrigatorio':
                                    formGrupDadosBancarios.controls['otherBankId'].errors && isFormSubmited
                                }">
                                <ng-option *ngFor="let option of listaDeBancosNaoConveniados" [value]="option.id">
                                  {{ option.name }}
                                </ng-option>
                              </ng-select>
                              <app-validacao-form-input
                                [nomeFormulario]="formGrupDadosBancarios"
                                nomeCampo="otherBankId"
                                [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                            </div>
                            <!-- Agência -->
                            <div class="form-group mb-1 col-sm-12 col-md-4">
                              <label for="agency">Agência</label>
                              <br />
                              <input
                                type="text"
                                (ngModelChange)="onFieldChange()"
                                id="agency"
                                maxlength="5"
                                class="form-control round"
                                id="agency"
                                formControlName="agency"
                                [ngClass]="{
                                  'is-invalid': formGrupDadosBancarios.controls['agency'].errors && isFormSubmited
                                }" />
                              <app-validacao-form-input
                                [nomeFormulario]="formGrupDadosBancarios"
                                nomeCampo="agency"
                                [maxLength]="10"
                                [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                            </div>
                            <!-- Digito -->
                            <div class="form-group mb-1 col-sm-12 col-md-2">
                              <label for="agencyDigit">Digito</label>
                              <br />
                              <input
                                type="text"
                                (ngModelChange)="onFieldChange()"
                                id="agencyDigit"
                                maxlength="5"
                                class="form-control round"
                                id="agencyDigit"
                                formControlName="agencyDigit"
                                [ngClass]="{
                                  'is-invalid': formGrupDadosBancarios.controls['agencyDigit'].errors && isFormSubmited
                                }" />
                              <app-validacao-form-input
                                [nomeFormulario]="formGrupDadosBancarios"
                                nomeCampo="agencyDigit"
                                [maxLength]="10"
                                [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                            </div>
                            <!-- Conta -->
                            <div class="form-group mb-1 col-sm-12 col-md-4">
                              <label for="account">Conta</label>
                              <br />
                              <input
                                type="text"
                                (ngModelChange)="onFieldChange()"
                                class="form-control round"
                                id="account"
                                maxlength="10"
                                formControlName="account"
                                [ngClass]="{
                                  'is-invalid': formGrupDadosBancarios.controls['account'].errors && isFormSubmited
                                }" />
                              <app-validacao-form-input
                                [nomeFormulario]="formGrupDadosBancarios"
                                nomeCampo="account"
                                [maxLength]="10"
                                [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                            </div>
                            <!-- Digito -->
                            <div class="form-group mb-1 col-sm-12 col-md-2">
                              <label for="accountDigit">Digito</label>
                              <br />
                              <input
                                type="text"
                                (ngModelChange)="onFieldChange()"
                                class="form-control round"
                                id="accountDigit"
                                maxlength="5"
                                formControlName="accountDigit"
                                oninput="
                                  this.value = Math.min(parseInt(this.value))
                                    .toString()
                                    .replace(/[^0-9]/g, '')
                                "
                                [ngClass]="{
                                  'is-invalid': formGrupDadosBancarios.controls['accountDigit'].errors && isFormSubmited
                                }" />
                              <app-validacao-form-input
                                [nomeFormulario]="formGrupDadosBancarios"
                                nomeCampo="accountDigit"
                                [maxLength]="12"
                                [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Botões -->
                  <div class="button-mobile d-flex justify-content-between w-100 mt-3">
                    <button matStepperPrevious class="btn-simule btn btn-outline-secondary btn-min-whidth">
                      <i class="fa fa-arrow-left"></i>
                      Voltar
                    </button>
                    <button
                      [disabled]="formGrupDadosBancarios.invalid || formGrupDadosBancarios.errors"
                      (click)="cadastrarDadosBancario(stepper)"
                      [ngbTooltip]="
                        formGrupDadosBancarios.invalid ? 'Preencha todos os campos do formulário para prosseguir' : null
                      "
                      class="btn-simule btn btn-outline-secondary btn-min-whidth">
                      Próximo
                      <i class="fa fa-arrow-right"></i>
                    </button>
                  </div>
                </mat-step>
              </mat-horizontal-stepper>
            </ng-container>
          </div>
        </block-ui>
      </ng-template>
    </div>
  </div>
</section>

<ng-template #template>
  <div class="modal-header bg bg-warning">
    <h5 class="modal-title white title-modal" id="exampleModalLongTitle">Outro Banco</h5>
    <button (click)="fecharModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center container">
    <div class="modal-body">
      <h2 class="mb-1">Favor entrar em contato com o corretor.</h2>
      <p class="mt-1">
        O pagamento do seu plano é contratualmente via débito automático e foi selecionado um banco no qual não temos
        convênio, pedimos que entre em contato com seu corretor.
      </p>
    </div>
  </div>

  <div class="modal-footer">
    <button data-dismiss="modal" (click)="fecharModal()" type="button" class="round btn btn-info">
      <i class="fa fa-check"></i>
      Ciente e continuar
    </button>
  </div>
</ng-template>
<!-- modal redução carencia -->
<ng-template #modalReducaoCarencia let-modal>
  <div class="modal-body">
    <app-reducao-carencia-proposta
      [dadosOperadoraDM]="dadosOperadoraDM"
      [entidadeProposta]="nomeEntidade"
      [razaoSocialEntidade]="razaoSocialEntidade"
      [codigoProposta]="codigoProposta"
      [mostrarQuadroDoisReducaoCarencia]="ehReducaoCarencia"
      [beneficiarios]="listaDeBeneficiarios"
      [modalidadeProduto]="modalidadeProduto"
      [listaBeneficiariosCarencias]="listaBeneficiariosCarencias"></app-reducao-carencia-proposta>
    <div class="card-content">
      <div class="card-body">
        <div class="row" style="background: #fff; border-radius: 5px">
          <div class="mb-1 mt-2">
            <input [(ngModel)]="checkboxReducaoCarencia" id="checkboxPortabilidade" type="checkbox" />
            <label
              style="margin-top: -10px"
              class="termo-aceite bold alinhamento-texto-check-box"
              for="checkboxPortabilidade">
              Li e concordo com o Termo de Aditivo de Redução de Carência
              <a class="ml-1"></a>
            </label>
          </div>
        </div>
        <div class="modal-footer">
          <!-- Buttons -->
          <div class="button-mobile d-flex justify-content-end w-100 mt-2">
            <button
              [disabled]="!checkboxReducaoCarencia"
              class="btn-simule btn btn-outline-secondary btn-min-whidth"
              (click)="concordarReducaoCarencia()">
              <i class="fa fa-check"></i>
              Assinar e Avançar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<!-- Modal Confirmação de Dados do Beneficiário -->
<ng-template #modalConfirmacaoDadosBeneficiarios let-modal>
  <app-modal-simples [title]="'Confirmar Dados do(s) Beneficiário(s)'" (cancel)="fecharModal()">
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12 text-center mb-1">
          <h4>Tem certeza de que os dados estão corretos?</h4>
          <div class="col-md-12 mt-1 mb-2" style="text-align: justify">
            <h6>
              * Ao confirmar as informações, elas não poderão mais ser alteradas (Apenas visualizadas posteriormente).
            </h6>
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-center">
        <button type="button" class="btn btn-success round box-shadow-4 mr-2" (click)="validarCampos(stepper)">
          <i class="ft-thumbs-up"></i>
          Confirmar
        </button>
        <button type="button" class="btn btn-warning round box-shadow-4" (click)="fecharModal()">
          <i class="ft-thumbs-down"></i>
          Cancelar
        </button>
      </div>
    </div>
  </app-modal-simples>
</ng-template>

<!--   modal Form Inscricao Entidade
  -->
<ng-template #modalFormInscricaoEntidade let-modal>
  <div class="modal-body">
    <app-formulario-inscricao-entidade-adservip
      *ngIf="this.nomeEntidade === 'ADSERVIP'"
      (aoFecharModalInscricao)="aoFecharModalInscricao($event)"
      [nomeEntidade]="nomeEntidade"
      [retornoDadosFormularioEntidade]="retornoDadosFormularioEntidade"></app-formulario-inscricao-entidade-adservip>
    <app-formulario-inscricao-entidade-abje
      *ngIf="this.nomeEntidade === 'ABJE'"
      [logoEntidade]="logoEntidade"
      [nomeEntidade]="nomeEntidade"
      [retornoDadosFormularioEntidade]="retornoDadosFormularioEntidade"
      (aoFecharModalInscricao)="aoFecharModalInscricao($event)"></app-formulario-inscricao-entidade-abje>
  </div>
</ng-template>
<ngx-spinner type="ball-newton-cradle" [fullScreen]="true" bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff">
  <p style="color: white">Carregando....</p>
</ngx-spinner>
<!-- Modal associar a entidade -->
<ng-template #modalInformativoParaAssociar let-modal>
  <div class="modal-body">
    <div class="card-content">
      <div class="card-body">
        <div class="d-flex" style="justify-content: space-evenly">
          <img [src]="logoEntidade" alt="Logo" style="width: 200px" />
        </div>
        <p class="mt-1">Olá {{ nomeBeneficiario }}!</p>
        <p>
          Para continuar com a contratação do
          <b>Plano de {{ descricaoTipoProduto }} {{ descricaoModalidadeProduto }}</b>
          , é necessário ser associado a entidade:
        </p>
        <p>
          <b>{{ nomeEntidade }} - {{ razaoSocialEntidade }}</b>
        </p>
        <p class="mt-2">
          Após concluir o cadastro como sócio, salve o termo de associação e retorne a esta página para prosseguir com a
          contratação.
        </p>
        <div class="d-flex justify-content-center mt-2 mb-2">
          <button
            type="button"
            class="btn btn-success round box-shadow-4 mr-2"
            (click)="aoAssociarBeneficiario(stepper)">
            Realizar sua Associação.
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Modal da Súmula 21 -->
<ng-template #modalSumula21 let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Termo de Orientação da Súmula 21</h4>
  </div>
  <div class="modal-content">
    <app-orientacao-portabilidade-sumula-proposta
      [razaoSocialEntidade]="razaoSocialEntidade"
      [entidadeProposta]="entidadeProposta"
      [codigoProposta]="codigoProposta"
      [mostrarHeader]="false"
      [mostrarOrientacaoSumula]="mostrarSumula"
      [operadoraVM]="dadosOperadoraDM"></app-orientacao-portabilidade-sumula-proposta>
    <div class="card-body">
      <div class="row">
        <div class="mb-1">
          <input [(ngModel)]="checkboxSumula" id="checkboxSumula" type="checkbox" />
          <label class="termo-aceite bold alinhamento-texto-check-box" for="checkboxSumula">
            Li e concordo com o Manual de Súmula 21
            <a class="ml-1"></a>
          </label>
        </div>
      </div>
    </div>
  </div>
  <!-- Buttons -->
  <div class="modal-footer">
    <button
      [disabled]="!checkboxSumula"
      (click)="concordarSumula()"
      class="btn-simule btn btn-outline-secondary btn-min-whidth">
      <i class="fa fa-check"></i>
      Assinar e Avançar
    </button>
  </div>
</ng-template>

<!-- Modal de Portabilidade-->
<ng-template #modalPortabilidade let-modal>
  <app-orientacao-portabilidade-sumula-proposta
    [razaoSocialEntidade]="razaoSocialEntidade"
    [entidadeProposta]="entidadeProposta"
    [codigoProposta]="codigoProposta"
    [mostrarHeader]="false"
    [mostrarOrientacaoPortabilidade]="mostrarPortabilidade"></app-orientacao-portabilidade-sumula-proposta>
  <div class="card-body">
    <div class="row">
      <div class="mb-1 mt-2">
        <input [(ngModel)]="checkboxPortabilidade" id="checkboxPortabilidade" type="checkbox" />
        <label class="termo-aceite bold alinhamento-texto-check-box" for="checkboxPortabilidade">
          Li e concordo com o Manual de Portabilidade
          <a class="ml-1"></a>
        </label>
      </div>
    </div>
  </div>
  <!-- Buttons -->
  <div class="modal-footer">
    <button
      [disabled]="!checkboxPortabilidade"
      (click)="concordarPortabilidade()"
      class="btn-simule btn btn-outline-secondary btn-min-whidth">
      <i class="fa fa-check"></i>
      Assinar e Avançar
    </button>
  </div>
</ng-template>
<!-- Modal de Reajuste Udemo *ngIf="ehReajusteUdemo(dataCriacaoProposta)"-->
<ng-template #modalReajusteUdemo let-modal>
  <app-documento-reajuste-udemo
    [entidadeProposta]="entidadeProposta"
    [razaoSocialEntidade]="razaoSocialEntidade"
    [codigoProposta]="codigoProposta"
    [vigenciaProposta]="vigenciaProposta"
    [dadosOperadoraDM]="dadosOperadoraDM"
    [nomeTitular]="nomeTitular"
    [cpfTitular]="cpfTitular"
    [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-documento-reajuste-udemo>
  <div class="card-body">
    <div class="row">
      <div class="mb-1 mt-2">
        <input [(ngModel)]="checkboxReajusteUdemo" id="checkboxReajusteUdemo" type="checkbox" />
        <label class="termo-aceite bold alinhamento-texto-check-box" for="checkboxReajusteUdemo">
          Li e concordo com o Reajuste Udemo
          <a class="ml-1"></a>
        </label>
      </div>
    </div>
  </div>
  <!-- Buttons -->
  <div class="modal-footer">
    <button
      [disabled]="!checkboxReajusteUdemo"
      (click)="concordarReajusteUdemo()"
      class="btn-simule btn btn-outline-secondary btn-min-whidth">
      <i class="fa fa-check"></i>
      Assinar
    </button>
  </div>
</ng-template>
